module.exports = __webpack_public_path__ + "static/assets/2fae472ae4c51fdf0dd4183aebadca0b.png";